import { RewardIcon } from '@shipt/design-system-icons'
import { trackElementClicked, trackElementViewed } from '@/features/shared/analytics/element'
import { PromoBanner } from '@shipt/design-system-banner'
import { formatPrice } from '@/features/shared/utils/formatter'
import { type LoyaltyProgram } from '@/features/account/services/RewardsPrograms/types'
import { DynamicRewardsDrawer } from '@/features/shop/components/Drawer/RewardsDrawer/DynamicRewardsDrawer'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { useEffect } from 'react'

type Props = {
  loyaltyProgram: LoyaltyProgram
  loyaltyRewardsPrice: number
}

export const ProductDetailLoyaltyBanner = ({ loyaltyProgram, loyaltyRewardsPrice }: Props) => {
  const { openDialog } = useHandleDialog()

  useEffect(
    () =>
      trackElementViewed({
        next_location: 'LoyaltyProgramForm',
        content: 'store_rewards',
        message_goal: 'loyalty_program_with_store_rewards',
        type: 'Banner',
      }),
    [],
  )

  const handleOnClick = () => {
    trackElementClicked({
      next_location: 'LoyaltyProgramForm',
      content: 'store_rewards',
      message_goal: 'loyalty_program_with_store_rewards',
      type: 'Banner',
    })
    openDialog(DynamicRewardsDrawer, {
      rewardProgram: loyaltyProgram,
      mode: 'add',
    })
  }

  const title = `${formatPrice(loyaltyRewardsPrice)} with rewards card`
  const description = 'Link your store rewards card to your account for extra savings.'

  return (
    <PromoBanner
      actionButton={{
        content: 'Link',
        onClick: handleOnClick,
      }}
      description={description}
      icon={RewardIcon}
      title={title}
      variant="neutral"
    />
  )
}
